import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const Areas = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Areas</h1>
        <p>Learn how to calculate areas of different shapes with this coding project.</p>
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/areas.gif" 
            alt="Areas" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project demonstrates how to calculate areas of various geometric shapes using Python code.</p>
        <h2>Download</h2>
        <a href="/Areas.py" download>Download Areas.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to calculate areas of shapes interactively.</p>
      </div>
    </div>
  );
};

export default Areas;
